module.exports = __webpack_public_path__ + "static/img/apiyun.bf83f486.svg";